<template>
  <div class="bg">
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"
             color="#00F">
    </loading>
    <b-container>
      <div class="app flex-row align-items-center">
        <div class="container">
          <vue-snotify></vue-snotify>
          <b-row class="justify-content-center">
            <b-col md="5">
              <b-card-group>
                <b-card no-body class="p-4">
                  <b-card-body>

                    <ValidationObserver ref="forgot_password_form" v-slot="{ passes }">

                      <b-form action="#" @submit.prevent="passes(forgotPassword)">
                        <h5 class="text-color animated slideInDown">Forgot Password</h5>
                        <p class="text-muted p animated slideInDown">Enter Your Email</p>


                        <ValidationProvider
                                vid="email"
                                name="Email"
                                v-slot="{ errors }"
                                rules="required|valid_email"
                        >


                        <!-- username input -->
                        <div class="group animated slideInUp">
                          <input type="text" v-model="email">
                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label><i class="cui-user icons font-xl"></i><span class="span-input">Email</span></label>
                          <span
                                  class="msg-paragraph"
                                  v-for="(error, index) in errors"
                                  v-bind:key="index"
                          >
                              {{ error }}
                            </span>
                        </div>
                        <!-- end of username input -->

                        </ValidationProvider>

                        <b-row>
                          <b-col cols="8" class="log-btn animated slideInUp">
                            <b-button variant="primary" class="btn-block p-btn-color ripple" type="submit">Submit</b-button>
                          </b-col>
                        </b-row>

                      </b-form>

                    </ValidationObserver>



                  </b-card-body>
                </b-card>
              </b-card-group>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="2" class="ml-2">
              <b-row class="justify-content-center">
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>


<script>
import { mapState, mapActions , mapGetters } from "vuex";
import router from "@/router";

export default {
  name: "forgotPassword",
  data() {
    return {
      email: "",
      isLoading: false,
      fullPage: true,
    };
  },
  methods: {
    ...mapActions("login", ["SubmitForgotPassword"]),
    async forgotPassword() {
      const userdata = {
        email: this.email
      };
      this.isLoading = true;
      await this.SubmitForgotPassword(userdata);
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
  .card-group{
    background-color: #f2f2f2;
    border: solid 1px #e3e3f2;
    border-radius: 10px;
    opacity: 0.8;
    border-radius: 10px;
  }
  .msg-paragraph{
    color: #fd3939;
  }
  .bg {
    /* The image used for web */
    background: url("~@/assets/quick-quote-bg.png");

    /* Full height */
    height: 100vh;
    overflow: hidden;
    /* Center and scale the image nicely */
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .p-btn-color {
    background-color: #106afa !important;
    border: none !important;
  }

  a {
    color: #057ede !important;
  }

  .p {
    margin-bottom: 2rem !important;
  }

  .log-btn {
    margin-bottom: 1rem;
  }

  .text-color {
    color: #106afa !important;
  }

  .plane-margin {
    margin-left: 80px;
  }

  .group {
    position: relative;
    margin-bottom: 45px;
  }
  .group input {
    font-size: 18px;
    padding: 10px 10px 10px 10px;
    display: block;
    width: 100%;
    border: none;
    border-bottom: 1px solid #1069fa;
    background: none;
    color: #424242;
  }
  .group input:focus {
    outline: none;
  }

  .group label {
    color: #1069fa;
    font-size: 18px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 5px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }
  /* active durum */

  .group input:focus ~ label,
  input:valid ~ label {
    top: -20px;
    font-size: 14px;
    color: #1069fa;
  }

 .card {
    border: none !important;
    background-color: #004fc700;
  }

  .bar {
    position: relative;
    display: block;
    width: 100%;
  }
  .bar:before,
  .bar:after {
    content: '';
    height: 2px;
    width: 0;
    bottom: 1px;
    position: absolute;
    background: #106afa00;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }
  .bar:before {
    left: 50%;
  }
  .bar:after {
    right: 50%;
  }
  /* active durum bar */

  .group input:focus ~ .bar:before,
  .group input:focus ~ .bar:after {
    width: 50%;
  }

  .highlight {
    position: absolute;
    height: 0%;
    width: 100px;
    top: 25%;
    left: 0;
    pointer-events: none;
    opacity: 0.5;
  }
  /* active durum */

  .group input:focus ~ .highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
  }

  @-webkit-keyframes inputHighlighter {
    from {
      background: #ffffff;
    }
    to {
      width: 0;
      background: transparent;
    }
  }
  @-moz-keyframes inputHighlighter {
    from {
      background: #ffffff;
    }
    to {
      width: 0;
      background: transparent;
    }
  }
  @keyframes inputHighlighter {
    from {
      background: #ffffff;
    }
    to {
      width: 0;
      background: transparent;
    }
  }
  .span-input {
    margin-left: 10px;
    position: relative;
    top: -2px;
  }
  .forgot-and-create a {
    color: #000;
    font-size: 12px;
    text-decoration: none;
    font-weight: 100;
    margin-right: 10px;
  }

  /* Ripple effect */
  .ripple {
    background-position: center;
    transition: background 0.8s;
  }
  .ripple:hover {
    background: #47a7f5 radial-gradient(circle, transparent 1%, #47a7f5 1%) center/15000%;
  }
  .ripple:active {
    background-color: #6eb9f7;
    background-size: 100%;
    transition: background 0s;
  }


  @media (max-width: 768px) {
    .bg {
      /* The image used for mobile */
      background: url("~@/assets/bcg-m.jpg");
      /* Full height */
      height: 100vh;
      overflow: hidden;
      /* Center and scale the image nicely */
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    /*.card {*/
    /*  background-color: #ffffff;*/
    /*}*/
    .plane-margin {
      display: none;
    }

  }

</style>
